import base from "../baseurl";
import token from "../getTk";

const Show = async (id) => {
  const tokenA = token.get();

  const api = base.extend({
    hooks: {
      beforeRequest: [
        (request) => {
          request.headers.set("jwt", `${tokenA}`);
        },
      ],
    },
  });

  const status = await api
    .post("company-admins/showall", { json: { companyId: id } })
    .json();
  console.log(status);
  return status.data;
};

export default Show;
